import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import SectionHeading from './SectionHeading';
import CardGrid from './CardGrid';
import { brandColors } from '../theme';
import { fillCard, cardTitle, cardDescription, iconBox } from '../styles/alignedCards';

const steps = [
  {
    step: '01',
    icon: <SearchIcon />,
    title: 'Diagnóstico',
    description: 'Entendemos tu operación, oportunidades y prioridades de negocio.',
  },
  {
    step: '02',
    icon: <ArchitectureIcon />,
    title: 'Diseño',
    description: 'Definimos alcance, arquitectura y un plan claro de entrega.',
  },
  {
    step: '03',
    icon: <RocketLaunchIcon />,
    title: 'Implementación',
    description: 'Construimos, integramos y acompañamos la adopción en tu equipo.',
  },
];

const HowWeWork = () => (
  <Box component="section" id="process" sx={{ py: { xs: 6, md: 8 }, bgcolor: '#fff' }}>
    <Container maxWidth="lg">
      <SectionHeading
        label="Proceso"
        title="Cómo trabajamos"
        subtitle="Un camino simple: descubrir, diseñar e implementar."
      />
      <CardGrid columns={{ xs: 1, md: 3 }} gap={{ xs: 2, md: 3 }}>
        {steps.map((item) => (
          <Paper
            key={item.step}
            elevation={0}
            sx={{
              ...fillCard(),
              p: 3,
              border: `1px solid ${brandColors.mist}`,
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: brandColors.gold, fontWeight: 800, letterSpacing: 2 }}
            >
              {item.step}
            </Typography>
            <Box sx={{ ...iconBox, my: 2 }}>{item.icon}</Box>
            <Typography variant="h6" sx={cardTitle}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={cardDescription}>
              {item.description}
            </Typography>
          </Paper>
        ))}
      </CardGrid>
    </Container>
  </Box>
);

export default HowWeWork;
